import { Status } from './status';

export type InvitationType = 'email' | 'code';
export type InvitationTypeDisplayName = 'Email' | 'Easy Link';
export type InviteViewType = 'PendingInviteView' | 'MembershipCodeInviteView';

export const InvitationTypeDisplayNameMap: Record<InvitationType, InvitationTypeDisplayName> = {
  email: 'Email',
  code: 'Easy Link',
};

export type Invitee = {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  status: Status;
  redeemedAs?: string;
};

export type Redemption = {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
};

export type Invite = {
  id: string;
  name: string;
  email: string;
  type: InvitationType;
  orgId: string;
  active: boolean;
  redemptionCount: number;
  redemptionLimit?: number;
  expirationDate?: Date;
  workflowId?: string;
  searchData?: string;
  numInvited?: number;
  _type: InviteViewType;
};

type SentInviteEmail = {
  subject: string;
  body?: string;
  sender: { id: string };
  inviteeEmails: string[];
  timeSent: string;
};

export type EmailInvite = Invite & {
  type: 'email';
  invitees: Invitee[];
  emails: SentInviteEmail[];
};

export type EasyLinkInvite = Invite & {
  type: 'code';
  membershipCode: string;
  redemptions: Redemption[];
  redemptionLink: string;
};

export const isEmailInvite = (invite: Invite): invite is EmailInvite => invite.type === 'email';
export const isEasyLinkInvite = (invite: Invite): invite is EasyLinkInvite => invite.type === 'code';
